import { Btn, BtnOutLine } from '../Buttons/Buttons';

import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

interface IModalProps {
    show: boolean;
    handleClose: () => void;
    handleConfirm: () => void;
    title: string;
    description: string;
    disabled?: boolean;
}
const CustomModal = (props: IModalProps) => {
    const { show, handleClose, title, description, handleConfirm, disabled } = props;
    const { t } = useTranslation();
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{description}</Modal.Body>
            <Modal.Footer>
                <BtnOutLine text={t('btns.cancel')} disabled={disabled} onClick={handleClose} />
                <Btn text={t('btns.confirm')} disabled={disabled} onClick={handleConfirm} />
            </Modal.Footer>
        </Modal>
    );
};

export default CustomModal;
